import React from 'react';

const CondosHeading = () => {
  return (
    <h1 className='text-primary text-opacity-80 text-lg font-medium text-gray-900 mb-4 mt-4 sm:text-4xl'>
      Let’s talk real estate opportunities
    </h1>
  );
};

export default CondosHeading;
